import { render, staticRenderFns } from "./addCustomer_component.vue?vue&type=template&id=cb564eb4&scoped=true&"
import script from "../assets/js/addCustomer.js?vue&type=script&lang=js&"
export * from "../assets/js/addCustomer.js?vue&type=script&lang=js&"
import style0 from "./addCustomer_component.vue?vue&type=style&index=0&id=cb564eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb564eb4",
  null
  
)

export default component.exports